import { cardImageSources, type GenericCharacter } from './types'

export const genericGenio: GenericCharacter = {
  id: 'generic-genio',
  enabled: true,
  order: 13,
  displayName: 'Zafir',
  icon: '🧞',
  imageSources: cardImageSources('generic-genio'),
}
